export default __webpack_public_path__ + "static/media/f35be72697c62a59f19fab5a9c33e807b26e12a1012bc808f006213a5fb19ce0.ce18333b.svg";